import apiService, { buildQueryString } from './api';
class CuponsTermicosService {
    // Listar cupons térmicos
    async list(filters = {}) {
        const queryString = buildQueryString(filters);
        const response = await apiService.get(`/cupons-termicos${queryString}`);
        return response.data;
    }
    // Listar cupons agrupados por tipo
    async listGrouped() {
        const response = await apiService.get('/cupons-termicos/grouped');
        return response.data;
    }
    // Buscar cupom por ID
    async getById(id) {
        const response = await apiService.get(`/cupons-termicos/${id}`);
        return response.data;
    }
    // Criar cupom
    async create(data) {
        const response = await apiService.post('/cupons-termicos', data);
        return response.data;
    }
    // Atualizar cupom
    async update(id, data) {
        const response = await apiService.put(`/cupons-termicos/${id}`, data);
        return response.data;
    }
    // Deletar cupom (desativar)
    async delete(id) {
        await apiService.delete(`/cupons-termicos/${id}`);
    }
    // Duplicar cupom
    async duplicate(id) {
        const response = await apiService.post(`/cupons-termicos/${id}/duplicate`);
        return response.data;
    }
    // Obter cupons por tipo
    async getByTipo(tipo) {
        const response = await apiService.get(`/cupons-termicos/tipo/${tipo}`);
        return response.data;
    }
    // Definir cupom como padrão
    async setPadrao(id) {
        const response = await apiService.patch(`/cupons-termicos/${id}/set-padrao`);
        return response.data;
    }
    // Gerar preview do cupom
    async gerarPreview(id, dados) {
        const response = await apiService.post(`/cupons-termicos/${id}/preview`, dados);
        return response.data.preview;
    }
    // Imprimir cupom
    async imprimir(id, dados) {
        await apiService.post(`/cupons-termicos/${id}/imprimir`, dados);
    }
}
// Tipos de cupom térmico disponíveis
export const tiposCupomTermico = [
    { value: 'ORDEM_SERVICO_ABERTURA', label: 'Recebimento de Equipamento' },
    { value: 'ORDEM_SERVICO_FECHAMENTO', label: 'Entrega de Equipamento' },
    { value: 'ORCAMENTO', label: 'Orçamento' },
    { value: 'RECIBO', label: 'Recibo de Pagamento' }
];
// Configurações de papel térmico
export const configuracoesTermicas = {
    largurasPapel: [
        { value: 80, label: '80mm (Padrão)' },
        { value: 58, label: '58mm (Compacto)' }
    ],
    tamanhosFonte: [
        { value: 'pequena', label: 'Pequena' },
        { value: 'normal', label: 'Normal' },
        { value: 'grande', label: 'Grande' }
    ]
};
// Configuração padrão para novos cupons
export const configuracaoPadrao = {
    larguraPapel: 80,
    tamanhoFonte: 'normal',
    cortarPapel: true,
    abrirGaveta: false,
    incluirLogo: false,
    numeroVias: 1
};
// Funções utilitárias
export const getTipoCupomLabel = (tipo) => {
    const tipoEncontrado = tiposCupomTermico.find(t => t.value === tipo);
    return tipoEncontrado?.label || tipo;
};
export const getStatusCupom = (ativo) => {
    return ativo
        ? { label: 'Ativo', color: 'green' }
        : { label: 'Inativo', color: 'red' };
};
const cuponsTermicosService = new CuponsTermicosService();
export default cuponsTermicosService;
